var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _circle, _ellipse2, _path13, _ellipse3, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1299,
    height: 810,
    viewBox: "0 0 1299 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1085.6 630L1029.07 609.331C1028.28 609.042 1027.76 608.292 1027.76 607.452V553.255C1027.76 551.952 1028.98 550.997 1030.25 551.315L1030.39 551.351M1085.6 630V572.5M1085.6 630L1121.25 590.254C1121.58 589.887 1121.76 589.411 1121.76 588.918V537.471M1085.6 572.5L1030.39 551.351M1085.6 572.5L1121.76 537.471M1030.39 551.351L1065.6 515.944C1066.17 515.372 1067.03 515.198 1067.78 515.502L1121.76 537.471",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.76 585.158V631.508C1190.76 631.99 1190.93 632.456 1191.25 632.82L1217.48 663M1190.76 585.158L1217.48 611.323M1190.76 585.158L1237.89 576.21C1238.57 576.08 1239.28 576.317 1239.74 576.836L1263.76 603.474M1217.48 663V611.323M1217.48 663L1262.13 654.467C1263.08 654.287 1263.76 653.463 1263.76 652.503V603.474M1217.48 611.323L1263.76 603.474",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.76 485.591V526.978L1235.93 548M1197.76 485.591L1235.93 506.613M1197.76 485.591L1235.93 458L1274.76 479.679M1235.93 548V506.613M1235.93 548L1274.76 521.723V479.679M1235.93 506.613L1274.76 479.679",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.26 460V486.429M1236.26 486.429L1220.76 497M1236.26 486.429L1251.76 495.018",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.52 425L1234.76 458.393L1273 480L1294.76 446.607L1256.52 425Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.76 420L1205.76 438",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.76 430L1195.76 452",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.76 459L1184.76 468",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.176 147.717C276.549 102.978 253.995 82.5824 243.047 77.9769C278.256 91.4768 308.517 74.8294 319.247 64.8183L325.816 83.8982C348.413 82.8455 349.245 51.8791 346.836 36.5274C343.12 12.842 312.546 -12.554 262.097 6.92064C211.648 26.3953 189.401 73.81 184.584 95.083C145.696 90.3459 109.698 124.251 96.5599 141.796C82.9841 159.999 62.2701 209.694 88.0203 262.855C120.208 329.305 214.544 293.048 227.282 283.908C271.293 252.328 282.461 203.641 279.176 147.717Z",
    fill: "#223B41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.259 129C349.259 136.643 347.438 143.44 344.623 148.242C341.773 153.103 338.201 155.5 334.759 155.5C331.317 155.5 327.744 153.103 324.895 148.242C322.08 143.44 320.259 136.643 320.259 129C320.259 121.357 322.08 114.56 324.895 109.758C327.744 104.897 331.317 102.5 334.759 102.5C338.201 102.5 341.773 104.897 344.623 109.758C347.438 114.56 349.259 121.357 349.259 129Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.259,
    cy: 129.5,
    rx: 2.5,
    ry: 4.5,
    fill: "#223B41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278.759 144L320.759 134",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M330.18 84C334.757 90.5749 347.456 104.543 359.602 111.615C372.025 118.847 374.64 130.024 368.756 139.229L359.602 153.694C366.14 163.776 376.471 189.067 365.486 209.581M320.372 293.083C319.501 284.973 322.857 265.731 343.256 253.633M249.759 299V265.468",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 302.259,
    cy: 181.5,
    r: 2.5,
    fill: "#223B41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.759,
    cy: 205.5,
    rx: 3,
    ry: 2.5,
    fill: "#223B41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.759 217C328.281 220.683 333.411 228.44 341.759 230",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 317.759,
    cy: 198.5,
    rx: 3,
    ry: 2.5,
    fill: "#223B41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M369.711 281.723L378.892 279.095C382.609 277.562 389.647 276.992 388.074 286.98C386.5 296.968 358.738 298.15 357.251 286.98C356.707 282.89 356.818 276.966 358.596 271.21M378.892 253.468C366.923 255.313 361.103 263.095 358.596 271.21M358.596 271.21C353.284 268.932 346.873 263.368 350.611 255.44M362.497 243.612C355.902 247.964 352.264 251.933 350.611 255.44M350.611 255.44C344.736 252.154 339.414 242.035 365.12 227.842M380.859 229.813C371.023 229.156 350.431 225.476 346.758 216.014C343.086 206.552 354.847 205.501 361.186 206.158C369.274 207.472 389.122 213.649 403.812 227.842C422.174 245.583 463.489 291.58 483.162 332.976C498.901 366.094 525.57 409.856 536.937 427.597C559.452 462.642 595.302 535.36 500.869 537.989C476.605 538.664 441.192 509.339 404.468 486.735",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.74 651.233C150.177 668.232 143.056 703.423 111.078 708.191C79.0998 712.96 39.2144 713.269 23.269 712.828C13.0027 713.711 -4.77751 711.635 6.23139 696.27C17.2403 680.904 34.8456 678.388 42.2721 679.05C62.1493 680.375 101.773 673.619 101.248 636",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M765.759 659C772.566 657.903 790.002 650.309 797.381 633.981C806.604 613.57 825.709 605.011 832.297 612.911C837.567 619.232 835.371 623.446 834.932 624.763",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M582.95 645.183C505.015 639.953 473.683 615.549 467.759 604C480.265 722.319 796.877 694.863 789.637 681.136C783.844 670.154 775.375 662.615 771.864 660.218C717.889 626.226 680.369 651.72 582.95 645.183Z",
    fill: "#223B41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M312.522 793.788C219.614 779.155 189.136 724.686 193.095 698.265C215.53 763.979 362.019 771.432 423.378 724.686C468.566 690.26 469.788 623.066 466.929 598C478.806 634.583 504.709 643.453 541.493 660.327C572.507 674.554 695.02 672.07 754.628 667.102C784.321 664.627 811.855 686.165 794.219 745.01C767.825 833.081 428.657 812.08 312.522 793.788Z",
    fill: "#223B41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M388.404 281C394.535 294.138 406.929 329.347 407.454 365.081L361.472 309.246C353.37 300.05 331.386 284.416 308.263 295.451L245.858 302.02C196.81 374.715 97.4 529.959 92.1448 569.372C86.8897 608.785 97.8379 630.462 103.969 636.374C115.574 647.541 145.485 663.175 172.286 636.374C177.614 631.047 182.009 625.994 185.618 621.266M199.876 579.882C197.248 591.706 200.163 602.211 185.618 621.266M185.618 621.266C179.86 659.803 189.365 739.374 273.448 749.358C357.531 759.343 408.768 738.629 423.877 727.024C441.175 712.354 474.458 666.985 469.203 602.873L440.956 512.223",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M810.069 664.182C806.403 684.091 799.814 691.033 795.014 692.997C802.869 730.326 787.814 759.796 772.759 767C783.668 765.69 809.545 760.844 825.778 751.938C842.012 743.031 849.125 725.96 850.652 718.538C853.925 700.419 860.078 658.812 858.507 637.331C856.936 615.851 843.015 620.086 836.251 624.889C829.051 629.691 813.734 644.273 810.069 664.182Z",
    stroke: "#223B41",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcError);
export default __webpack_public_path__ + "static/media/oc-error.c9ccdff43996b73f5354c4adc7783e9c.svg";
export { ForwardRef as ReactComponent };